import { Box, FormControl, InputLabel, Select, MenuItem, useTheme } from "@mui/material"
import PanelTabsCareers from "./PanelTabsCareers"
import { TableCareers } from "./TableCareers"
import { FormatUploadCareers } from "./FormatUploadCareers"
import { FormCreateCareer } from "../Forms/CreateCareer/Form-CreateCareer"
import { DetailFacultyTab } from "../Faculties/DetailFacultyTab"
import { useAuth, tokens } from "@/utilities"
import { useState, useMemo, useEffect } from "react"
import { useParams, useLocation } from "react-router-dom"


export const TabsCareers = () => {
    const {user} = useAuth()
    const { id } = useParams<string>();
    const location = useLocation();
    const role = user?.userData.role
    const isIESOrSuperAdmin = role === "Administrador IES" || role === "Super Administrador"
    const theme = useTheme()
    const colors = tokens(theme.palette.mode)
    
    const [selectedTab, setSelectedTab] = useState(0);

    const rawUidFaculty = user?.userData.uidFaculty;
    const rawFaculty = user?.userData.faculty;

    const availableFaculties = useMemo(() => {
      if (!rawUidFaculty) return [];
      const ids = Array.isArray(rawUidFaculty) ? rawUidFaculty : [rawUidFaculty];
      const names = Array.isArray(rawFaculty) ? rawFaculty : [rawFaculty];
      return ids.map((id, index) => ({
        id,
        name: names[index] || id
      }));
    }, [rawUidFaculty, rawFaculty]);

    const [activeFaculty, setActiveFaculty] = useState<{ id: string; name: string } | null>(null);

    useEffect(() => {
      if (id) {
        setActiveFaculty({ id, name: location.state?.facultyName || id });
      } else if (availableFaculties.length > 0 && !activeFaculty) {
        setActiveFaculty(availableFaculties[0]);
      }
    }, [id, availableFaculties]);

    const handleChangeTab = (tab:number) => {
      setSelectedTab(tab);
    };  

    const facultyId = activeFaculty?.id || id || "";
    const facultyName = activeFaculty?.name || location.state?.facultyName || "";

    const data = [
        {
            name: "Facultad",
            link: <DetailFacultyTab facultyId={facultyId} facultyName={facultyName}/>
        },
        {
            name: "Activas",
            link: <TableCareers state={true} facultyId={facultyId} facultyName={facultyName}/>
        },
        {
            name: "Inactivas",
            link: <TableCareers state={false} facultyId={facultyId} facultyName={facultyName}/>
        },
        {
            name: "Crear Carrera",
            link: <FormCreateCareer facultyId={facultyId} handleChangeTab={handleChangeTab}/>
        },
        {
            name: "Subir Carreras",
            link: <FormatUploadCareers facultyId={facultyId} />
        },
    ]

    const dataIES = [
      {
        name: "Facultad",
        link: <DetailFacultyTab facultyId={facultyId} facultyName={facultyName}/>
      },
      {
        name: "Activas",
        link: <TableCareers state={true} facultyId={facultyId} facultyName={facultyName}/>
      },
      {
        name: "Inactivas",
        link: <TableCareers state={false} facultyId={facultyId} facultyName={facultyName}/>
      },
      {
        name: "Crear Carrera",
        link: <FormCreateCareer facultyId={facultyId} handleChangeTab={handleChangeTab}/>
      },
      {
        name: "Subir Carreras",
        link: <FormatUploadCareers facultyId={facultyId} />
      },
    ]

  return(
    <Box>
      {role === "Administrador Facultad" && availableFaculties.length > 1 && activeFaculty && (
        <Box sx={{ padding: "10px 20px", display: "flex", justifyContent: "flex-start" }}>
          <FormControl sx={{ minWidth: 200 }} size="small">
            <InputLabel id="active-faculty-label" sx={{ color: `${colors.grey[100]} !important` }}>Facultad Activa</InputLabel>
            <Select
              labelId="active-faculty-label"
              id="active-faculty-select"
              value={activeFaculty.id}
              label="Facultad Activa"
              onChange={(e) => {
                const selected = availableFaculties.find(f => f.id === e.target.value);
                if (selected) setActiveFaculty(selected);
              }}
              sx={{ color: colors.grey[100], backgroundColor: colors.primary[400] }}
            >
              {availableFaculties.map((f) => (
                <MenuItem key={f.id} value={f.id}>{f.name}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      )}
      <PanelTabsCareers data={isIESOrSuperAdmin ? dataIES : data} selectedTab={selectedTab} setSelectedTab={setSelectedTab}/>
    </Box>
  )
}
